// extracted by mini-css-extract-plugin
export default {"form-item":"Register_form-item__8+T40","form-item-label":"Register_form-item-label__7stHq"};